export const path = {
  LOGIN: '/ident',
  CHOICE: '/choice',
  LETTER: '/letter',
  OTC: '/otc',
  PASSWORD: '/password',
  CONTACT: '/contact',
  CONFIRM: '/confirm',
  ERROR: '/error',
};

export const routesCanGoBack = [path.ERROR, path.LOGIN, path.CHOICE, path.OTC];

export const stepOrder = {
  [path.LOGIN]: 1,
  [path.CHOICE]: 2,
  [path.OTC]: 3,
  [path.PASSWORD]: 4,
  [path.CONTACT]: 5,
  [path.CONFIRM]: 6,
  [path.ERROR]: 7,
};
